SC.suggestedseries = (function () {
  var api = {};

  var init = function () {
    handleEvents();

    if (!Modernizr.objectfit) {
      handleOldBrowsers();
    }
  };

  // Setup event handlers.
  var handleEvents = function () {
    var $seriesContainer = $('.suggested-series-container');

    $seriesContainer.on('mouseenter click', '.card-series__more-info-icon', handleHoverInfo);
    $seriesContainer.on('mouseleave', '.card-series-container', handleHoverInfo);
    $seriesContainer.on('click', '.card-series__close-more-info', handleHoverInfo);

    // Handles adding a suggested series to the cart.
    $('.suggested-series__card-container .button__primary').on('click keypress', function (e) {
      // If it's a keypress event, just return if its not the enter key
      if (e.type === 'keypress' &&  e.key !== 'Enter') {
        return;
      }

      // Get the product info and log mParticle and GA events.
      var $form = $(this).closest('form');
      var $productInfo = $form.find('.product-info');
      var seriesName = $productInfo.data('series-name');
      var productName = (seriesName === '1') ? 'A single class.' : 'A set of ' + seriesName + ' classes.';
      var baseSku = $productInfo.data('series-id');
      var sku = SC.utils.getSku('Series', baseSku, seriesName);
      var attrs = {'Base Sku': baseSku};
      var unitPrice = $productInfo.data('series-price');
      var product = SC.analytics.mp.createProduct(
        productName,
        sku,
        unitPrice,
        '1',
        null,
        attrs
      );

      /**
       * Fist set the currency code for the event, then log the event.
       * mParticle Event: Product Event - Add To Cart - Suggested Series page.
       */
      SC.analytics.mp.setCurrencyCode($productInfo.data('currency-code'));
      SC.analytics.mp.logProductEvent('AddToCart', product, {'Location': 'New Rider'});

      // Submit the form to add the product to the bag.
      $form.submit();
    });

    $('#suggested-series-cancel').on('click', function () {
      SC.analytics.mp.logEvent('Click No Thanks', 'navigation', {'Location': 'New Rider'});
    });

    $('#view-all-series-button').on('click', function () {
      SC.analytics.mp.logEvent('Click View All Series Options', 'navigation', {'Location': 'New Rider'});
    });
  };

  /**
   * Handles finding the event and target block for styling
   *
   * @param {object} e triggered event
   * @returns {void}
   */
  var handleHoverInfo = function (e) {
    e.stopPropagation();

    var $this = $(e.currentTarget);

    // Set the default params on click and override in the switch
    var target = $this.parent('.card-series__credits-additional-info');
    var status = 'hide';
    // if the type is click and the current target is the more info icon (accessibility enter key)
    var activateClick = e.type === 'click' && e.currentTarget.classList.contains('card-series__more-info-icon');

    if (e.type === 'mouseenter' || activateClick ) {
      if (e.currentTarget.classList.contains('card-series__more-info-icon')) {
        target = $this.siblings('.card-series__credits-additional-info');
        status = 'show';
      }
    } else if (e.type === 'mouseleave') {
      target = $this.children('.card-series__credits-additional-info');
    }

    showToolTip(target, status);
  };

  /**
   * Assigns and removes block styling for hover of tool tip
   *
   * @param {object} target dom element
   * @param {string} status show or not
   * @returns {void}
   */
  var showToolTip = function (target, status) {
    if (status === 'show') {
      target.addClass('block');
    } else {
      target.removeClass('block');
    }
  };

  /**
   * Function to add CSS properties for older browsers. e.g. IE11
   * Moves image tags to the background so images do not stretch.
   * Adds the is-old-browser class to elements that need it.
   * @returns {void}
   */
  var handleOldBrowsers = function handleOldBrowsers() {
    var $container = $('.suggested-series__sidebar');
    var $img = $container.find('img');
    var $picture = $container.find('picture');
    var imgUrl = $img.prop('src');

    if (imgUrl) {
      $container
        .css('background-image', 'url(' + imgUrl + ')')
        .addClass('is-old-browser');
      $img.css('opacity', 0);
      $picture.css('opacity', 0);
    }

    $('.suggested-series-subcontainer').addClass('is-old-browser');
  };

  init();

  return api;
})();
